<template>
  <el-form
    v-if="item"
    label-position="top"
    size="mini"
    style="width: 800px"
    class="e-form"
  >
    <slot v-if="item.banks">
      <h4 class="flex items-center justify-between">
        <div>Banks</div>
        <a @click="addBank" class="no-underline">+ Add</a>
      </h4>
      <div v-if="item.errors?.banks" class="red">
        {{ item.errors?.banks }}
      </div>
      <div class="flex flex-col gap-1">
        <div
          v-for="(bank, index) in item.banks"
          :key="index"
          class="flex items-center gap-2"
        >
          <el-input
            v-model="bank.name"
            placeholder="Bank name"
            :class="{ 'line-through red': bank._destroy }"
            :disabled="bank._destroy"
            size="mini"
            clearable
          >
            <template slot="append">
              <slot v-if="bank._destroy">
                <a
                  class="el-icon-refresh-right text-base"
                  @click="restoreBank(bank)"
                />
              </slot>
              <slot v-else>
                <a
                  v-if="bank.deletable"
                  class="el-icon-delete text-base red"
                  @click="removeBank(bank)"
                />
                <i v-else class="el-icon-delete text-base cursor-not-allowed" />
              </slot>
            </template>
          </el-input>
        </div>
      </div>
    </slot>

    <slot v-if="item.performance">
      <h4>Financial Performance</h4>
      <div class="flex-start">
        <el-form-item label="Report Start Date" class="mr5">
          <el-date-picker
            size="mini"
            v-model="item.performance.report_start_date"
            type="date"
            :value-format="'yyyy-MM-dd'"
          />
        </el-form-item>
        <el-form-item label="Orders in Period By" class="mr5">
          <el-select v-model="item.performance.orders_in_period">
            <el-option
              v-for="name in ['None', 'SuperAdmin']"
              :key="name"
              :label="name"
              :value="name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Orders by Hub By" class="mr5">
          <el-select v-model="item.performance.orders_by_hub">
            <el-option
              v-for="name in ['None', 'Admin', 'SuperAdmin']"
              :key="name"
              :label="name"
              :value="name"
            />
          </el-select>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="Visible Fields (Orders by Hub)">
          <el-select
            v-model="item.performance.orders_by_hub_fields"
            multiple
            filterable
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="name in ['Receivable', 'Payable', 'DailyCost', 'Profit']"
              :key="name"
              :label="name"
              :value="name"
            />
          </el-select>
        </el-form-item>
      </div>
    </slot>
    <slot v-if="item.auto_number_prefix">
      <h4>Auto Number Prefix</h4>
      <div class="flex-start">
        <el-form-item label="Order Receivable Invoice" class="mr5">
          <el-input
            v-model="item.auto_number_prefix.order_receivable_invoice"
          />
        </el-form-item>
        <el-form-item label="TP Receivable Invoice" class="mr5">
          <el-input v-model="item.auto_number_prefix.tp_receivable_invoice" />
        </el-form-item>
        <el-form-item label="Order Payable Payment" class="mr5">
          <el-input v-model="item.auto_number_prefix.order_payable_payment" />
        </el-form-item>
        <el-form-item label="TP Payable Payment">
          <el-input v-model="item.auto_number_prefix.tp_payable_payment" />
        </el-form-item>
      </div>
    </slot>
    <h4>Others</h4>
    <div class="flex items-center bg-white gap-6 p-2">
      <popup
        componentPath="components/html"
        class="no-underline"
        width="960px"
        :options="{ title: 'Payment Methods', url: '/payment_methods' }"
      >
        Payment Methods
      </popup>
      <popup
        componentPath="components/html"
        class="no-underline"
        width="90%"
        :options="{ title: 'Daily Costs', url: '/daily_costs' }"
      >
        Daily Costs
      </popup>
    </div>
    <br />
    <el-form-item>
      <el-button
        type="primary"
        @click="$emit('saveData', { bookkeeping: item }, 'bookkeeping', true)"
        >Save</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
import popup from "../../components/popup.vue";
export default {
  components: { popup },
  name: "SystemSettingFinancial",
  props: ["item"],
  data() {
    return {};
  },
  mounted() {
    if (!this.item.performance) this.$set(this.item, "performance", {});
    if (!this.item.auto_number_prefix)
      this.$set(this.item, "auto_number_prefix", {});
    if (!this.item.banks) this.$set(this.item, "banks", []);
  },
  computed: {
    errors() {
      return this.item.errors || {};
    },
  },
  methods: {
    addBank() {
      this.item.banks.push({
        name: "",
        deletable: true,
      });
    },
    removeBank(bank) {
      if (bank.id) this.$set(bank, "_destroy", true);
      else this.item.banks.splice(this.item.banks.indexOf(bank), 1);
    },
    restoreBank(bank) {
      this.$set(bank, "_destroy", false);
    },
  },
};
</script>
<style lang="scss" scoped></style>
